module.exports = __webpack_public_path__ + "static/img/1.b97bcf68.png";